export default function DashedConnector () {
  return (
    <div className="flex border-l-[3px] border-l-black h-full border-dashed" />
  );
};
